export default __webpack_public_path__ + "static/media/Ahilyawada-Maheshwar-157781-pixahive.525806d4.jpg";